import React from 'react'
import { TreeExpandToggle } from '../../Shared/TreeExpandToggle'
import { Checkbox } from '@mds/mds-reactjs-library';
import { useForceUpdate } from '../../../Hooks/useForceUpdate';

const CollapsibleCheckbox = ({ level, className, checked, label, item, showItem, checkBoxClicked, showDefinition, selection, isSelected, dimensionConfiguration, searchTerm }) => {
    const forceUpdate = useForceUpdate();

    return (
        <div className='collapsiable-checkbox'>
            <div className='parent'>
                {
                    showItem(item) &&
                    <div style={{ width: "100%" }}>
                        <div style={{ display: 'flex', width: "100%" }}>
                            <TreeExpandToggle
                                isExpanded={item.IsExpanded}
                                onToggle={() => { item.IsExpanded = !item.IsExpanded; forceUpdate(); }}
                            />
                            <Checkbox
                                className={className}
                                checked={checked}
                                value=""
                                label={label}
                                item={item}
                                onClick={() => { checkBoxClicked(item); }}
                            />
                        </div>
                        {
                            showDefinition && item.Comment && item.Comment !== 'NA' &&
                            <div className='comment'>
                                {item.Comment}
                            </div>
                        }
                    </div>
                }
            </div>
            {
                <div className={`children ${!item.IsExpanded && 'hideChildren'}`}>
                    {
                        item.Children
                            .map(cItem => cItem.Children && cItem.Children.length ?
                                <CollapsibleCheckbox
                                    level={level + 1}
                                    className={className}
                                    checked={isSelected(cItem)}
                                    label={cItem.DisplayName}
                                    item={cItem}
                                    showItem={showItem}
                                    checkBoxClicked={checkBoxClicked}
                                    showDefinition={showDefinition}
                                    selection={selection}
                                    key={cItem.AttributeID}
                                    isSelected={isSelected}
                                    dimensionConfiguration={dimensionConfiguration}
                                    searchTerm={searchTerm}
                                /> :
                                (
                                    showItem(cItem) &&
                                    <div key={cItem.AttributeID} style={{ width: '100%' }}>
                                        <div style={{ display: 'flex', width: '100%' }}>
                                            <div style={{ width: 32 }}></div>
                                            <Checkbox
                                                className={className}
                                                checked={isSelected(cItem)}
                                                value=""
                                                label={cItem.DisplayName}
                                                item={cItem}
                                                onClick={() => { checkBoxClicked(cItem); }}
                                            />
                                        </div>
                                        {
                                            showDefinition && cItem.Comment && cItem.Comment !== 'NA' &&
                                            <div className='comment'>
                                                {cItem.Comment}
                                            </div>
                                        }
                                    </div>
                                ))
                    }
                </div>
            }
        </div>
    )
}

export default CollapsibleCheckbox;